import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/roth-conversion-calculator',
  component: () => import('../../routes/RothConversionCalculator.svelte'),
  card: {
    id: 'roth-conversion-calculator',
    title: 'Roth Conversion Calculator',
    description: 'Compare converting a traditional IRA to a Roth IRA and see if paying taxes now saves you money in retirement.',
    icon: 'swap_horiz',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/roth-conversion-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Roth Conversion Calculator – Traditional to Roth IRA Comparison',
    description: 'Free Roth conversion calculator to compare paying taxes now vs. later. See if converting your traditional IRA to a Roth IRA saves you money considering your tax rates and investment returns.',
  },
};

export default meta;
